module.exports = {
  siteTitle: 'Jane Li | Software Engineer',
  siteDescription:
    'Jane Li is a software engineer based in Tokyo, Japan who specializes in building (and software design) exceptional websites, applications, and everything in between.',
  siteKeywords:
    'Jane Li, Jane, gatsby, fullstacktiger, software engineer, front-end engineer, extension, extension developer, javascript',
  siteUrl: 'https://trust-janeli.netlify.app/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Jane Li',
  location: 'Tokyo, Japan',
  email: 'janeli.home2020@gmail.com',
  github: 'https://github.com/fullstacktiger/portofolio',
  twitterHandle: '@janeli',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/fullstacktiger/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/jane-li-704b301a7/',
    },
    {
      name: 'Codepen',
      url: 'https://codepen.io/janeli',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/janeli1',
    },
  ],

  navLinks: [
    {
      name: 'About me',
      url: '/#about',
    },
    {
      name: 'Projects',
      url: '/archive/',
    },
    {
      name: 'Pensieve',
      url: '/pensieve/',
    },
    {
      name: 'Blog',
      url: '/blog',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
